var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 16596"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 326",
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#E7F4FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 16595"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M60.3928 69.6443L19.8319 66.5256L23.9121 13.4599L64.473 16.5786L60.3928 69.6443Z",
    fill: "#1C75BC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M64.3558 18.4023C64.3487 18.395 64.3417 18.3878 64.3346 18.3805L64.3941 17.6071L64.3558 18.4023Z",
    fill: "#D4E2E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M64.2649 19.2832L64.3343 18.3801C64.3414 18.3874 64.3484 18.3946 64.3555 18.4019L64.3443 18.6343C64.3273 18.8549 64.3007 19.0713 64.2649 19.2832Z",
    fill: "#DDE6E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "M45.017 25.4114C43.5667 25.4114 42.1212 25.2085 40.7193 24.8057L28.1629 21.1979C25.6647 20.5747 23.9805 18.1412 24.1871 15.4536L24.3116 13.8346L64.4423 16.5768L64.3927 17.6068L64.3333 18.3802L64.2639 19.2833C63.8624 21.6518 62.2944 23.4265 59.9408 23.6413L46.9803 25.2871C46.3273 25.37 45.6717 25.4114 45.017 25.4114Z",
    fill: "#BDAA98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M59.5115 23.2649L46.5511 24.9106C44.451 25.1773 42.3246 25.0138 40.2901 24.4292L27.7335 20.8215C25.2354 20.1982 23.5511 17.7647 23.7578 15.0772L23.8822 13.4581L64.4431 16.5768L64.3187 18.1959C64.1119 20.8834 62.0755 23.0308 59.5115 23.2649Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M43.9939 20.5645C42.3794 20.4403 40.9651 21.6528 40.8409 23.2673L40.2503 30.9491C40.1261 32.5636 41.3386 33.978 42.953 34.1021C44.5675 34.2262 45.982 33.0138 46.106 31.3993L46.6967 23.7175C46.8209 22.103 45.6085 20.6887 43.9939 20.5645ZM42.9317 34.3798C41.1642 34.244 39.8365 32.6953 39.9725 30.9277L40.5632 23.2459C40.6991 21.4783 42.2478 20.1509 44.0153 20.2867C45.7828 20.4227 47.1104 21.9713 46.9745 23.7389L46.3838 31.4207C46.2479 33.1883 44.6992 34.5158 42.9317 34.3798Z",
    fill: "#F9DD82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M46.9194 22.6495C46.7891 24.3433 45.3106 25.6108 43.6168 25.4805C41.923 25.3503 40.6555 23.8717 40.7858 22.1779C40.916 20.4842 42.3946 19.2167 44.0883 19.3469C45.7821 19.4772 47.0496 20.9558 46.9194 22.6495Z",
    fill: "#AA7355"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M45.4254 22.5348C45.3587 23.4029 44.6009 24.0525 43.7328 23.9858C42.8648 23.919 42.2151 23.1612 42.282 22.2932C42.3487 21.4251 43.1065 20.7755 43.9745 20.8423C44.8426 20.909 45.4921 21.6668 45.4254 22.5348Z",
    fill: "#BDB39B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M44.5842 22.47C44.5533 22.8738 44.2007 23.1761 43.7967 23.145C43.3929 23.114 43.0906 22.7614 43.1218 22.3575C43.1528 21.9536 43.5054 21.6514 43.9093 21.6824C44.3131 21.7135 44.6154 22.0661 44.5842 22.47Z",
    fill: "#434244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M46.1753 32.3269C46.0451 34.0205 44.5665 35.288 42.8727 35.1578C41.179 35.0276 39.9115 33.549 40.0418 31.8552C40.172 30.1614 41.6506 28.894 43.3443 29.0243C45.0381 29.1545 46.3056 30.6331 46.1753 32.3269Z",
    fill: "#AA7355"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M44.6826 32.2121C44.6158 33.0801 43.858 33.7298 42.99 33.663C42.1219 33.5962 41.4723 32.8385 41.539 31.9704C41.6058 31.1023 42.3636 30.4528 43.2317 30.5195C44.0997 30.5862 44.7493 31.344 44.6826 32.2121Z",
    fill: "#BDB39B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M43.8414 32.1467C43.8104 32.5506 43.4578 32.8528 43.0539 32.8218C42.65 32.7907 42.3478 32.4382 42.3788 32.0343C42.4099 31.6304 42.7625 31.3282 43.1663 31.3592C43.5702 31.3903 43.8724 31.7428 43.8414 32.1467Z",
    fill: "#434244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M55.5882 64.9392H17.4946V12.3964H55.5882V64.9392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    d: "M29.2027 22.8518C36.3226 22.8518 43.4424 22.8518 50.5622 22.8518C51.143 22.8518 51.143 21.9511 50.5622 21.9511C43.4424 21.9511 36.3226 21.9511 29.2027 21.9511C28.6219 21.9511 28.6219 22.8518 29.2027 22.8518Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M22.4516 28.1892C31.8214 28.1892 41.1913 28.1892 50.5612 28.1892C51.142 28.1892 51.142 27.2885 50.5612 27.2885C41.1913 27.2885 31.8214 27.2885 22.4516 27.2885C21.8708 27.2885 21.8708 28.1892 22.4516 28.1892Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    d: "M22.4516 33.5254C31.8214 33.5254 41.1913 33.5254 50.5612 33.5254C51.142 33.5254 51.142 32.6247 50.5612 32.6247C41.1913 32.6247 31.8214 32.6247 22.4516 32.6247C21.8708 32.6247 21.8708 33.5254 22.4516 33.5254Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M22.4516 38.8628C31.8214 38.8628 41.1913 38.8628 50.5612 38.8628C51.142 38.8628 51.142 37.9621 50.5612 37.9621C41.1913 37.9621 31.8214 37.9621 22.4516 37.9621C21.8708 37.9621 21.8708 38.8628 22.4516 38.8628Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    d: "M22.4516 44.199C31.8214 44.199 41.1913 44.199 50.5612 44.199C51.142 44.199 51.142 43.2983 50.5612 43.2983C41.1913 43.2983 31.8214 43.2983 22.4516 43.2983C21.8708 43.2983 21.8708 44.199 22.4516 44.199Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54_2",
    d: "M22.4516 49.512C31.8214 49.512 41.1913 49.512 50.5612 49.512C51.142 49.512 51.142 48.6112 50.5612 48.6112C41.1913 48.6112 31.8214 48.6112 22.4516 48.6112C21.8708 48.6112 21.8708 49.512 22.4516 49.512Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54_3",
    d: "M22.4936 54.8345C31.8635 54.8345 41.2334 54.8345 50.6032 54.8345C51.1841 54.8345 51.1841 53.9338 50.6032 53.9338C41.2334 53.9338 31.8635 53.9338 22.4936 53.9338C21.9128 53.9338 21.9128 54.8345 22.4936 54.8345Z",
    fill: "#BBBCBF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M33.5857 55.9749C33.4059 55.9749 33.4059 56.2537 33.5857 56.2537C33.7655 56.2537 33.7655 55.9749 33.5857 55.9749Z",
    fill: "#3B464C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.6b2ed6c77e75696182a8cbb38b6f5472.svg";
export { ForwardRef as ReactComponent };